"use client";
import React, { useState } from "react";
import { Button } from "../../../components/Actions/Button";
import { useUser } from "../../../hooks/useUser";
import { StatusBanner } from "../../../components/StatusBanner/StatusBanner";
import Link from "next/link";
import { createInitialProfile } from "../../../utils/supabase/actions";
import { useRouter } from "next/navigation";

export default function Initial() {
  const { authenticated, holder, wallet, user } = useUser();
  const [submitStatus, setSubmitStatus] = useState("idle");

  const router = useRouter();
  const createProfile = async () => {
    setSubmitStatus("submitting");
    const privyId = user?.id;
    if (!wallet || !privyId || !holder.isHolder) return;
    const data = await createInitialProfile({
      wallet: wallet.address,
      privyId,
      token_class: holder.class
    });

    console.log(data);

    if (data) {
      console.log("pushing");
      router.push("/coop/onboarding/1");
    }
  };

  return (
    <section className="flex min-h-screen flex-col items-center py-24 px-8 md:py-32 md:px-12 max-w-5xl mx-auto">
      <h2 className="subhead1 mb-8 text-center text-balance">
        {" "}
        Get ready to use your NFT to join as an official Coinage DAO Member!
      </h2>
      <p className="body1">
        Eligible and active Coinage DAO Members will be able to track their
        activity and see whether they have earned a patronage dividend at the
        end of the year. We are making history together! But first, we need to
        collect some important information.
      </p>
      {!authenticated && <p>Please Connect your wallet to continue</p>}
      {authenticated && holder.isHolder && (
        <Button
          modifier="primary"
          onClick={() => createProfile()}
          loading={submitStatus === "submitting"}>
          Begin
        </Button>
      )}
      {authenticated && !holder.isHolder && (
        <StatusBanner
          title="Sorry, you aren’t eligible."
          containerClassName="mt-12">
          Membership in the Coinage DAO/Coop to unlock dividends is limited to
          Caucus and Network pass holders.{" "}
          <Link
            target="_blank"
            href="https://app.unlock-protocol.com/checkout?id=f73b962e-ac43-45e7-bf1f-f2f0a444708f"
            className="underline">
            Upgrade now!
          </Link>
        </StatusBanner>
      )}
    </section>
  );
}
